import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer font-primary">
        <Container fluid={true}>
          <Row>
            <Col sm={6} className="font-primary">
              {new Date().getFullYear()} © iAssistant.
            </Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block font-primary">by SemeCloud</div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
